import { useCustomLocale } from '@group-link-one/gl-components';
import { useMainLayoutTranslations } from '../locale';
import type { IMainLayoutTranslations } from '../types/mainLayout.types';

export const useMainLayoutTranslate = () => {
  const mainLayoutTranslate = useMainLayoutTranslations();

  const { customLocale } = useCustomLocale<IMainLayoutTranslations>(mainLayoutTranslate);

  return {
    customLocale,
  };
};
